import React from 'react';

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

/**
 * Monotone stroke icons for topbar links (inherits `currentColor`).
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {number} [props.size] — width/height in px (default 18 desktop, use 22 on mobile drawer)
 */
export const TopbarIconDashboard = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="4" y="4" width="6" height="6" rx="1" {...stroke} />
    <rect x="14" y="4" width="6" height="6" rx="1" {...stroke} />
    <rect x="4" y="14" width="6" height="6" rx="1" {...stroke} />
    <rect x="14" y="14" width="6" height="6" rx="1" {...stroke} />
  </svg>
);

export const TopbarIconInbox = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4 6h16v12H4V6Z" {...stroke} />
    <path d="m4 6 8 5 8-5" {...stroke} />
  </svg>
);

export const TopbarIconSignup = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" {...stroke} />
    <circle cx="12" cy="7" r="4" {...stroke} />
    <path d="M20 8v6M23 11h-6" {...stroke} />
  </svg>
);

export const TopbarIconLogin = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M15 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4" {...stroke} />
    <path d="m10 17 5-5-5-5M15 12H3" {...stroke} />
  </svg>
);

export const TopbarIconListings = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01" {...stroke} />
  </svg>
);

export const TopbarIconProfileSettings = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="9" r="3" {...stroke} />
    <path d="M6 21v-1a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1" {...stroke} />
  </svg>
);

export const TopbarIconAccountSettings = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="3" {...stroke} />
    <path
      d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
      {...stroke}
    />
  </svg>
);

export const TopbarIconSearch = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="11" cy="11" r="7" {...stroke} />
    <path d="m21 21-4.35-4.35" {...stroke} />
  </svg>
);

export const TopbarIconLogout = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M10 17H6a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h4" {...stroke} />
    <path d="M14 12h7m0 0-3-3m3 3-3 3" {...stroke} />
  </svg>
);
